import { render, staticRenderFns } from "./GenericTHGTagTable.vue?vue&type=template&id=7142605e&scoped=true"
import script from "./GenericTHGTagTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericTHGTagTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GenericTHGTagTable.vue?vue&type=style&index=0&id=7142605e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142605e",
  null
  
)

export default component.exports